<template>
    <div class="container">
        <div class="row">
                <div>
                    <h2 style="margin-top: 30px;">IEH Pozos</h2>

                    <p class="justifi px-5" style="margin-top: 30px;">Es un sistema desarrollado para el monitoreo y control de pozos profundos, cumpliendo los requerimientos de la Normativa DGA 1238.</p>
                    
                    <p class="justifi px-5">IEH Pozos se encarga de capturar toda la información de tus pozos en tiempo real y la envía a una plataforma web www.iehcontrol.com, donde la podrás visualizar.</p>
        
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-1"></div>
                <div class="col-10">
                    <div class="row new-t">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6">Variable</div>
                                <div class="col-3">Básica</div>
                                <div class="col-3">Avanzada</div>
                            </div>
                        </div>
                        <div class="col-12 new-tbody">
                            <div class="row">
                                <div class="col-6 justifi">Monitoreo de caudal</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Totalizador de litros extraídos</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Monitoreo de nivel freático</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Datalogger para respaldo de información</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Control de Encendido y apagado manual</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Reportes diarios</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Alertas de tiempo de trabajo</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Sensor de Presión de Matriz (tubería)</div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Encendido automático según nivel de Tranque o Estanque</div>
                                <div class="col-3"></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Monitoreo de variables Eléctricas</div>
                                <div class="col-3"></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Interacción con variador de Frecuencia</div>
                                <div class="col-3"></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                            <div class="row">
                                <div class="col-6 justifi">Control y programación de Horarios Punta</div>
                                <div class="col-3"></div>
                                <div class="col-3"><i class="far fa-check-circle"></i></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <br>

            <div class="row">
                <h5 style="margin-top:30px; margin-bottom: 30px;">Podemos brindar distintas soluciones y configuraciones, tanto sea como:</h5>
            </div>

            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <ul class="list-unstyled feature-one__point">
                        <li>
                            <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p>Automatización de llenado de tranques y/o estanques.</p>
                         </div>
                        </li>
                    </ul>  
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4">
                    <ul class="list-unstyled feature-one__point">
                        <li>
                            <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p>Comando de Retro-impulsiones.</p>
                         </div>
                        </li>
                    </ul>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4">
                    <ul class="list-unstyled feature-one__point">
                        <li>
                            <div >
                             <span class="fa fa-check"></span>
                        </div>
                         <div class="justifi2">
                            <p>Interacción con variadores de frecuencia.</p>
                         </div>
                        </li>
                    </ul>
                </div>
            </div>
    </div>
    <div>
        <img src=" assets/images/other/IEH-caudal.png" alt="" class="med">
    </div>
</template>
    <style>
        .justifi{
            text-align: justify;
        }
        .justifi2{
            text-align: justify;
            font-family: Arial, Helvetica, sans-serif !important; 
            font-weight: 0px !important;
            color: #2c3e50 !important;
            margin-left: 14px;
        }
        .new-t{
            border: solid 2px #1B2C85;
            border-radius: 18px;
        }
        .new-tbody{
            border-top: solid 2px #1B2C85;
        }
        .new-tbody > div{
            border-top: solid 1px gray;
        }
        .new-tbody > div > div + div{
            border-left: solid 2px #1B2C85;
        }
        
        .med{
            width: 100%;
            height: 100%;
        }

        @media only screen and (max-width: 1024px){
            
        }
        
    </style>
<script>
</script>